import { Outlet, createFileRoute } from '@tanstack/react-router'

const parseNumber = ({
  value,
}: {
  readonly value: unknown
}): number | undefined => {
  if (typeof value === 'number') {
    return Number.isNaN(value) ? undefined : value
  }

  if (typeof value !== 'string') {
    return undefined
  }

  const parsed = Number.parseInt(value, 10)
  if (Number.isNaN(parsed)) {
    return undefined
  }

  return parsed
}

export const Route = createFileRoute('/_layoutPortfolio/setting/action-type')({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    p?: number
    s?: number
  } => {
    return {
      p: parseNumber({ value: search.p }),
      s: parseNumber({ value: search.s }),
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
